import { AxiosRequestConfig } from "axios";
import { URL_POST_USER_LOGIN } from "@/requests/user";
import MockAdapter from "axios-mock-adapter/types";
import PostUserLoginRequest from "@/models/api/user/PostUserLoginRequest";
import PostUserLoginResponse from "@/models/api/user/PostUserLoginResponse";

export const loginMock = (mock: MockAdapter): void => {
  mock.onPost(URL_POST_USER_LOGIN).reply((config: AxiosRequestConfig) => {
    const requestBody: PostUserLoginRequest = JSON.parse(config.data);
    if (
      requestBody.login === "testuser" &&
      requestBody.password === "testuser" &&
      ["832b2314-dbb7-4219-b6e4-ad45c1d75dfe", "cd895887-5796-4ae3-903b-c9489f274542"].includes(requestBody.officeId)
    ) {
      return [
        200,
        {
          token: "asdasdasd.asdasdasd.asdasd",
          redirectUrl: "/orders",
        } as PostUserLoginResponse,
      ];
    }
    return [401];
  });
};
